var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vueVideoArchive" }, [
    _c("div", { staticClass: "filterBar" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "ul",
          { staticClass: "padding-x" },
          [
            _c(
              "li",
              {
                staticClass: "catFilterItem",
                class: { active: _vm.currentCat === "all" },
                on: {
                  click: function($event) {
                    return _vm.filterItems("all")
                  }
                }
              },
              [_vm._v("\n          " + _vm._s(_vm.alllabel) + "\n        ")]
            ),
            _vm._v(" "),
            _vm._l(_vm.categories, function(cat) {
              return _c(
                "li",
                {
                  key: cat.term_id,
                  staticClass: "catFilterItem",
                  class: { active: _vm.currentCat === cat.category_nicename },
                  on: {
                    click: function($event) {
                      return _vm.filterItems(cat.category_nicename)
                    }
                  }
                },
                [_vm._v("\n          " + _vm._s(cat.name) + "\n        ")]
              )
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mobileFilterBar" }, [
      _c("div", { staticClass: "padding-x" }, [
        _c(
          "select",
          {
            on: {
              change: function($event) {
                return _vm.filterItems(null, 0, $event)
              }
            }
          },
          [
            _c("option", { attrs: { value: "all" } }, [
              _vm._v(_vm._s(_vm.showalllabel))
            ]),
            _vm._v(" "),
            _vm._l(_vm.categories, function(cat) {
              return _c(
                "option",
                {
                  key: cat.term_id,
                  domProps: { value: cat.category_nicename }
                },
                [_vm._v("\n          " + _vm._s(cat.name) + "\n        ")]
              )
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid-x container" },
      _vm._l(_vm.postsToShow, function(post) {
        return _c(
          "div",
          { key: post.post_name, staticClass: "cell large-4 medium-6" },
          [
            _c(
              "a",
              { staticClass: "vueGridItem", attrs: { href: post.path } },
              [
                _c("div", { staticClass: "teaserImgContainer" }, [
                  _c("img", { attrs: { alt: "", src: post.featured_img_url } }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "playBtn",
                    attrs: { src: _vm.vicon }
                  })
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v(_vm._s(post.post_title))]),
                _vm._v(" "),
                _c("p", { staticClass: "postExcerpt" }, [
                  _vm._v(_vm._s(post.post_excerpt))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "postCategory" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        post.categories[0] ? post.categories[0].name : ""
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "postDate" }, [
                  _vm._v(_vm._s(post.post_date))
                ])
              ]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.showShowMore
      ? _c(
          "button",
          {
            staticClass: "showMoreBtn",
            on: {
              click: function($event) {
                return _vm.filterItems(_vm.currentCat, 9)
              }
            }
          },
          [_vm._v("\n    " + _vm._s(_vm.showmorelabel) + "\n  ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }